/* The Locker Room CR - sin dependencias. Menu, barra pegada, revelar al
   scroll, variantes de la ficha y la personalizacion como producto aparte. */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var dinero = function (c) { return "₡" + (c / 100).toLocaleString("es-CR", { maximumFractionDigits: 0 }); };

  var btnMenu = $("#btn-menu"), hoja = $("#sheet");
  if (btnMenu && hoja) {
    var abrir = function (si) {
      hoja.hidden = !si;
      btnMenu.setAttribute("aria-expanded", si ? "true" : "false");
      document.documentElement.style.overflow = si ? "hidden" : "";
    };
    btnMenu.addEventListener("click", function () { abrir(hoja.hidden); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !hoja.hidden) { abrir(false); btnMenu.focus(); }
    });
    hoja.addEventListener("click", function (e) { if (e.target.tagName === "A") { abrir(false); } });
  }

  var nav = $("#nav");
  if (nav) {
    var alScroll = function () { nav.classList.toggle("is-stuck", window.scrollY > 40); };
    alScroll();
    window.addEventListener("scroll", alScroll, { passive: true });
  }

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ocultos = $$(".rv");
  if (!reduce && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (filas) {
      filas.forEach(function (f) {
        if (f.isIntersecting) { f.target.classList.add("in"); io.unobserve(f.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    ocultos.forEach(function (el) { io.observe(el); });
  } else {
    ocultos.forEach(function (el) { el.classList.add("in"); });
  }

  var datos = $("[data-variantes]");
  if (datos) {
    var variantes = JSON.parse(datos.textContent);
    var campoId = $("[data-variante]");
    var salPrecio = $("[data-precio]");
    var botonAdd = $("[data-agregar]");

    var elegidas = function () {
      var v = [];
      $$(".pdp-opt").forEach(function (fs, i) {
        var on = $(".chip[aria-pressed='true']", fs);
        v[i] = on ? on.getAttribute("data-val") : null;
      });
      return v;
    };

    var refrescar = function () {
      var sel = elegidas();
      var hit = variantes.filter(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
      if (!hit) { return; }
      campoId.value = hit.id;
      if (salPrecio) { salPrecio.textContent = dinero(hit.price); }
      if (botonAdd) {
        botonAdd.disabled = !hit.available;
        botonAdd.textContent = hit.available ? "Agregar al carrito" : "Agotado";
      }
      var url = new URL(location);
      url.searchParams.set("variant", hit.id);
      history.replaceState(null, "", url);
    };

    $$(".pdp-opt .chip").forEach(function (chip) {
      chip.addEventListener("click", function () {
        var fs = chip.closest(".pdp-opt");
        $$(".chip", fs).forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
        chip.setAttribute("aria-pressed", "true");
        refrescar();
      });
    });

    var foto = $("#pdp-foto");
    $$(".pdp-thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        $$(".pdp-thumb").forEach(function (o) { o.classList.remove("is-on"); });
        t.classList.add("is-on");
        if (foto) { foto.src = t.getAttribute("data-foto"); foto.removeAttribute("srcset"); }
      });
    });
  }

  var check = $("#quiere-pers");
  if (check) {
    var campos = $(".pdp-pers-campos");
    check.addEventListener("change", function () { campos.hidden = !check.checked; });

    var form = $("#form-producto");
    var idPers = $("[data-pers-id]");
    if (form && idPers) {
      var persId = JSON.parse(idPers.textContent);
      form.addEventListener("submit", function (e) {
        if (!check.checked || !persId) { return; }
        e.preventDefault();
        var fd = new FormData(form);
        var items = [
          { id: Number(fd.get("id")), quantity: 1, properties: {
              "Nombre": fd.get("properties[Nombre]") || "",
              "Numero": fd.get("properties[Numero]") || ""
            } },
          { id: Number(persId), quantity: 1 }
        ];
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () { location.href = "/cart"; })
          .catch(function () { form.submit(); });
      });
    }
  }
})();
